import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { BRAND, OFFER_ANCHOR, PACK_IMAGE, PRODUCT } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="bg-navy" data-id="element-93" data-mp="4lyuukqi8cd4">
      <div className="bg-coal" data-id="element-94" data-mp="4mrxb9ifkfpg">
        <p className="mx-auto max-w-page px-3 py-1 text-center text-[0.58rem] font-black uppercase tracking-[0.28em] text-solar sm:text-[0.7rem]" data-id="element-95" data-mp="4jm53lei8xpi">
          {BRAND}
        </p>
      </div>

      <div className="mx-auto flex max-w-page flex-col items-center px-3 pb-4 pt-2.5 text-center sm:px-6 sm:pb-5" data-id="element-96" data-mp="xb5slhi4wxxb">
        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="max-w-4xl font-display text-[1.35rem] uppercase leading-[1.02] text-white sm:text-3xl lg:text-[2.85rem]" data-id="element-97" data-mp="sddz4j1ud3r0">
          ☀️ Deja de perderte entre tutoriales y aprende{' '}
          <span className="bg-solar px-1 text-coal" data-id="element-98" data-mp="3j9kc5f0exnhp">energía solar</span> desde
          cero
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.05
      }} className="mt-1.5 max-w-2xl text-[0.8rem] font-extrabold leading-snug text-solar sm:text-sm" data-id="element-99" data-mp="3o6amdlpjdov7">
          Seguí una ruta práctica para dimensionar, conectar e instalar sistemas
          fotovoltaicos paso a paso, desde cero.
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.09
      }} className="mt-2 block w-full max-w-xl" data-id="element-100" data-mp="35akly2x950jf">
          <img src={PACK_IMAGE} alt={`${PRODUCT}: 6 módulos digitales y 5 bonos incluidos`} className="mx-auto w-full rounded-lg border-2 border-solar shadow-[0_12px_32px_rgba(4,29,59,0.5)]" data-id="element-101" data-mp="2hkgl23bg7ew4" />
        </motion.a>

        <p className="mx-auto mt-2 max-w-3xl font-body text-[0.78rem] leading-snug text-white/85 sm:text-sm" data-id="element-102" data-mp="nbl1chqpya8v">
          Con <span className="font-bold text-solar" data-id="element-103" data-mp="ibgnkzh73tmc">{PRODUCT}</span> aprenderás
          a comprender cómo funciona la energía solar, reconocer los componentes
          de un sistema fotovoltaico, analizar consumos, realizar estimaciones
          básicas, entender las etapas de una instalación y descubrir cómo
          comenzar a desarrollarte profesionalmente en el sector.{' '}
          <span className="font-bold text-white" data-id="element-104" data-mp="112g5xhu6q56n">
            Incluso si hoy estás comenzando desde cero.
          </span>
        </p>

        <div className="mt-2.5 flex w-full flex-col items-center gap-1" data-id="element-105" data-mp="x0cq6h0hgefk">
          <CtaButton size="lg" data-id="element-106" data-mp="3ltgoxvs8x0qz">
            ☀️ ¡SÍ! QUIERO APRENDER ENERGÍA SOLAR DESDE CERO
          </CtaButton>
          <p className="flex items-center gap-1.5 text-[0.68rem] font-bold uppercase tracking-wide text-white/80 sm:text-xs" data-id="element-107" data-mp="3hqah4jphj1ie">
            <ShieldCheckIcon size={14} className="text-solar" data-id="element-108" data-mp="1xb5qyhfqoxhp" />
            🛡️ Garantía de Devolución de 7 Días
          </p>
        </div>
      </div>
    </header>;
}